import http from '@/http'

const URL = '/admin/badge-builder'
const SETTINGS_URL = '/admin/settings'

// Templates
export const listTemplates = async (params) => {
  return http.get(URL + '/templates', { params: params })
}

export const getTemplate = async (id) => {
  return http.get(URL + '/templates/' + id + '?include=elements,labelSize')
}

export const saveTemplate = (payload) => {
  if (payload.id) {
    return http.put(URL + '/templates/' + payload.id, payload)
  }
  return http.post(URL + '/templates', payload)
}

export const deleteTemplate = async (id) => {
  return http.delete(URL + '/templates/' + id)
}

export const duplicateTemplate = async (id) => {
  return http.post(URL + '/templates/' + id + '/duplicate')
}

export const setAsDefault = async (id) => {
  return http.put(URL + '/templates/' + id + '/set-default')
}

// Presets (Modelos pré-definidos)
export const listPresets = async () => {
  return http.get(URL + '/presets')
}

// Label Sizes
export const listLabelSizes = async (params) => {
  return http.get(URL + '/label-sizes', { params: params })
}

export const listLabelSizesByPrinter = async (printerModel) => {
  return http.get(URL + '/label-sizes', { params: { printer_model: printerModel } })
}

// Print Queue
export const listPrintQueue = async (params) => {
  return http.get(URL + '/print-queue', { params: params })
}

export const markAsPrinted = async (id) => {
  return http.put(URL + '/print-queue/' + id + '/printed')
}

export const retryPrint = async (id) => {
  return http.put(URL + '/print-queue/' + id + '/retry')
}

export const cancelPrint = async (id) => {
  return http.delete(URL + '/print-queue/' + id)
}

export const clearPrintQueue = async () => {
  return http.delete(URL + '/print-queue')
}

// Preview
export const previewBadge = async (templateId, participantId) => {
  return http.post(URL + '/preview', { template_id: templateId, participant_id: participantId })
}

// Template padrão e impressão
export const getDefaultTemplate = async () => {
  return http.get(URL + '/default-template')
}

export const printBadge = async (participantId) => {
  return http.get(URL + '/print/' + participantId)
}

// Impressão em massa: 1 request com até 200 IDs (chunking feito no caller)
export const printBulk = async (participantIds) => {
  return http.post(URL + '/print-bulk', { participant_ids: participantIds })
}

// Marca como impresso em massa: até 500 IDs por request
export const markPrintedBulk = async (participantIds) => {
  return http.post(URL + '/mark-printed-bulk', { participant_ids: participantIds })
}

// Settings
export const getAccreditationSettings = async () => {
  return http.get(SETTINGS_URL + '/accreditation')
}

export const saveAccreditationSettings = (payload) => {
  // Backend usa POST para salvar/atualizar.
  // Suporta FormData (upload de banner/logo) ou JSON simples.
  if (typeof FormData !== 'undefined' && payload instanceof FormData) {
    var fdId = payload.get('id') || 1
    return http.post(SETTINGS_URL + '/accreditation/' + fdId, payload, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
  var id = payload.id || 1 // Default ID 1 se não existir
  return http.post(SETTINGS_URL + '/accreditation/' + id, payload)
}

export default {
  listTemplates,
  getTemplate,
  saveTemplate,
  deleteTemplate,
  duplicateTemplate,
  setAsDefault,
  listPresets,
  listLabelSizes,
  listLabelSizesByPrinter,
  listPrintQueue,
  markAsPrinted,
  retryPrint,
  cancelPrint,
  clearPrintQueue,
  previewBadge,
  getDefaultTemplate,
  printBadge,
  printBulk,
  markPrintedBulk,
  getAccreditationSettings,
  saveAccreditationSettings
}
